import React, { Component } from 'react';
import NominationDataService from '../services/nomination-data-services';
import { AppConstants } from '../../../common/APIConstants';
export class CopyDownEditor extends Component {
    constructor(props) {
        super(props);

        let expType = this.props?.colDef?.cellEditorParams?.type;
        let expSubType = this.props?.colDef?.cellEditorParams?.subType;

        if (expType === 'select') {
            let options = [];
            let key = 0;

            this.props.colDef.cellEditorParams.subType.forEach(
                (item) => {
                    options.push(<option key={key} value={item}>{item}</option>);
                    key++;
                }
            );

            let selectedValue = '';
            if ((this.props.value != null) && (this.props.value != '')) {
                selectedValue = this.props.value;
            }

            this.state = {
                values: options,
                selectedValue: selectedValue
            };
        } else {
            this.textInput = React.createRef();
            this.state = {
                numValue: this.props.node.data[this.props.colDef.field],
            }
        }

        this.regExp = /^-?([1-9]\d*|0)?(\.|\.\d|\.\d\d)?$/;
        if (!(['F1', 'F2', 'F3', 'F4'].includes(
            this.props.data?.product.toString()))) {
            switch (expType) {
                case 'Decimal':
                    switch (expSubType) {
                        case '1': case 1:
                            this.regExp = /^([1-9]\d*|0)(\.)?(\.\d)?$/;
                            break;
                        case '2': case 2:
                            this.regExp = /^([1-9]\d*|0)(\.)?(\.\d)?(\.\d\d)?$/;
                            break;

                        default:
                            this.regExp = /^([1-9]\d*|0)(\.)?(\.\d)?$/;
                            break;
                    }
                    break;

                case 'Numeric':
                    switch (expSubType) {
                        case 'non-zero':
                            this.regExp = /^-?([1-9]\d*|0)?(\.|\.\d|\.\d\d)?$/;
                            break;
                        case 'positive':
                            this.regExp = /^([1-9]\d*|0)?(\.|\.\d|\.\d\d)?$/;
                            break;
                        case 'negative':
                            this.regExp = /^(-|-([1-9]\d*|0)?(\.)?(\.\d+)?|0(\.)?(\.([0-4])?([0-4][0-4])?([0-4][0-4]\d*)?)?)?$/;
                            break;

                        default:
                            this.regExp = /^([1-9]\d*|0)?(\.|\.\d|\.\d\d)?$/;
                            break;
                    }
                    break;

                default:
            }
        }
    }
    onKeyUp(e, regExp) {
        if ((e.key == "Backspace" || e.key == "Delete")
            && e.target.value != '' && !commonReg(e.nativeEvent, regExp))
            e.target.value = e.target.defaultValue;

        function commonReg(event, regExp) {
            return regExp.test(event.target.value);
        }
    }
    onKeyPress(e, regExp) {
        if (!commonReg(e.nativeEvent, regExp))
            e.preventDefault();

        function commonReg(event, regExp) {
            return regExp.test(event.target.value + event.key);
        }
    }
    afterGuiAttached() {
        if (this.textInput) this.textInput.current.focus();
    };

    getValue() {
        if (this.props?.colDef?.cellEditorParams?.type === 'select') {
            if (typeof this.state?.selectedValue !== 'undefined')
                return this.state?.selectedValue;
        }
        else
            return this.textInput.current.value;
    };

    componentDidMount() {
        if (this.props?.colDef?.cellEditorParams?.type !== 'select')
            this.textInput.current.addEventListener('keydown', this.onKeyDown);
    }

    valueUpdate = (rows, selectedFact, field) => {
        rows.map(async (e) => {
            if (e?.id > this.props?.data?.id) {
                let newData = {
                    Id: e?.id, ReferrenceDate: e?.referrenceDate, Fact: selectedFact,
                    FieldRef: field, Value: this.props?.value,
                    Editor: this.props.context.componentParent.state?.displayName
                };
                await NominationDataService.saveNominationData(newData);
            }
        });
    }

    render() {
        let expType = this.props?.colDef?.cellEditorParams?.type;
        return (
            <div>
                <div className='celleditordiv'>
                    {
                        expType !== 'select' && (
                            <input
                                className='celleditortext'
                                onKeyUp={(e) => this.onKeyUp(e, this.regExp)}
                                onKeyPress={(e) => this.onKeyPress(e, this.regExp)}
                                onChange={(e) => {
                                    this.props.node.setDataValue(this.props.colDef.field, e.target.value);
                                    this.setState({
                                        numValue: e.target.value
                                    })
                                }}
                                ref={this.textInput} defaultValue={this.props.value} />
                        )
                    }
                    {
                        expType === 'select' && (
                            <select className="ag-cell-edit-input"
                                value={this.state.selectedValue}
                                onChange={(e) => { this.setState({ selectedValue: e.target.value }) }}>
                                {this.state.values}
                            </select>
                        )
                    }
                </div>
                {
                    (!(['F1', 'F2', 'F3', 'F4'].includes(
                        this.props.data?.product.toString())))
                    && (<div className='celleditoricon'
                        title="Click to fill down" onClick={async () => {
                            let rIndx = this.props.rowIndex;
                            const data = this.props.data;
                            const selectedFact =
                                typeof data.facilityPipeline == 'undefined' ?
                                    data.product : data.facilityPipeline;
                            const field = this.props.colDef.field;
                            let rows = [];
                            this.props.api.forEachNodeAfterFilterAndSort((rowNode) => {
                                if (rowNode.data['id'] > data.id) {
                                    if (['nominationNotMetReasons', 'commentsBypass', 'commentsAssetLogistics',
                                        'e1targetOrMax', 'e2targetOrMax', 'e5targetOrMax',
                                        'e6targetOrMax'].includes(field.toString())) {
                                        rowNode.data[field] = this.props.value;
                                    } else {
                                        rowNode.data[field] =
                                            this.props.value.toString().replace(/,/g, '')
                                                .replace('%', '').replace(/\(/g, '-').replace(/\)/g, '');
                                    }
                                    rowNode.data['updatedBy'] =
                                        this.props.context.componentParent.state?.displayName;
                                    rowNode.data['updatedOn'] =
                                        new Date().toLocaleString('en-US',
                                            { timeZone: AppConstants.MT_TIME_FORMATTER });
                                }
                                rows.push(rowNode.data);
                            });
                            this.valueUpdate(rows, selectedFact, field);
                            let pinnedBottomData =
                                await this.props.context.componentParent.calculatePinnedBottomData(null, rows, null);
                            this.props.api.setPinnedBottomRowData(pinnedBottomData);
                            this.props.api.setRowData(rows);
                            this.props.api.ensureIndexVisible(rIndx, 'middle');
                        }}>&nbsp;
                    </div>)
                }
            </div>
        );
    }
}